.root {
  .input {
    border: 1.5px solid var(--mantine-color-tertiary-7);
    border-radius: 0.25rem;

    &:checked {
      border: none;
      background-color: var(--mantine-color-green-5);
    }

    &:disabled {
      border: none;
      background-color: var(--mantine-color-tertiary-0);
    }
  }
}
